<template>
  <div class="project-content" v-loading="loading">
    <el-button
      type="primary"
      @click="openEditWin('create')"
      >添加</el-button
    >
    <el-table :data="tableData" style="width: 100%">
      <el-table-column prop="project_id" label="ID" width="100"> </el-table-column>
      <el-table-column prop="project_name" label="项目名称"> </el-table-column>
      <el-table-column prop="project_leader" label="项目负责人">
        <template slot-scope="scope">
          <span>{{scope.row.project_leader}}[{{scope.row.uid}}]</span>
        </template>
      </el-table-column>
      <el-table-column prop="project_phone" label="负责人电话"> </el-table-column>
      <el-table-column prop="project_address" label="项目地址"> </el-table-column>
      <el-table-column prop="project_desc" label="项目描述"> </el-table-column>
      <el-table-column prop="edit" label="编辑" width="100">
        <template slot-scope="scope">
          <div class="edit-button">
            <i
              @click="openEditWin(scope.row)"
              class="el-icon-edit pointer mar-r10"
            ></i>
            <i
              class="el-icon-delete pointer"
              @click="delItem(scope.row.project_id)"
            ></i>
          </div>
        </template>
      </el-table-column>
    </el-table>
    <el-pagination
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
      :current-page="pageInfo.page"
      :page-sizes="[10, 20, 30, 40, 50, 100]"
      :page-size="pageInfo.pageSize"
      layout="sizes, total, prev, pager, next, jumper"
      :total="cnt_all"
    >
    </el-pagination>

    <!--新增对话框-->
    <el-dialog
      class="dialog600"
      :title="editType === 'create' ? '添加项目' : '修改项目'"
      :visible.sync="dialogVisible"
      v-if="dialogVisible"
    >
      <el-form
        :model="editOne"
        label-position="left"
        label-width="100px"
        :rules="editOneRule"
        ref="dialogRef"
      >
        <div class="user-info">
          <el-form-item label="项目名称" prop="project_name">
            <el-input v-model="editOne.project_name"></el-input>
          </el-form-item>
          <el-form-item label="项目所属" prop="uid">
            <el-select
              clearable
              filterable 
              placeholder="请选择所属子账户"
              v-model="editOne.uid"
              style="width: 100%"
            >
              <template v-for="t in devSelect">
                <el-option
                  v-if="parseInt($store.state.user.id) != t.id"
                  :key="t.id"
                  :label="t.username"
                  :value="t.id"
                ></el-option>
              </template>
            </el-select>
          </el-form-item>
          <el-form-item label="项目地址" prop="project_address">
            <el-input v-model="editOne.project_address"></el-input>
          </el-form-item>
          <el-form-item label="项目描述" prop="project_desc">
            <el-input
              type="textarea"
              :rows="2"
              v-model="editOne.project_desc"
              placeholder="请输入项目描述"
              >
            </el-input>
          </el-form-item>
        </div>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button class="mw-edit-button" @click="dialogVisible = false"
          >取消</el-button
        >
        <el-button
          type="primary"
          @click="createItem"
          v-if="editType === 'create'"
          >确 定</el-button
        >
        <el-button
          type="primary"
          @click="updateItem"
          v-if="editType === 'update'"
          >确 定</el-button
        >
      </div>
    </el-dialog>
  </div>
</template>

<script>
import projectApi from "@/api/auth/project";
import adminsApi from "@/api/auth/admins";
export default {
  data() {
    const vm = this;
    return {
      loading: false,
      dialogVisible: false,
      tableData: [],
      pageInfo: {
        page: 1,
        pageSize: 20,
      },
      cnt_all: 0,
      editOneRule: {
        project_name: [{ required: true, message: "请输入项目", trigger: "blur" }],
        uid: [{ required: true, message: "请选择项目所属账号！", trigger: "blur" }]
      },
      editType: -1,
      devSelect: [],
      editOne: {
        uid: '',
        project_phone: '',
        project_address: '',
        project_desc: ''
      }
    };
  },
  methods: {
    getTableData(pageIndex) {
      // 获取列表
      this.pageInfo.page = pageIndex;
      this.loading = true;
      projectApi.projectList(this.pageInfo).then((res) => {
        if (res.data.code === 1000) {
          this.loading = false;
          let resData = res.data.data;
          this.tableData = resData.list;
          this.pageInfo.page = pageIndex;
          this.cnt_all = parseInt(resData.count);
          this.getUserList()
        }
      });
    },

    // 获取账户列表
    getUserList() {
      adminsApi.userList({
        page: 1,
        pageSize: 50,
      }).then((res) => {
        let resData = res.data.data;
        this.devSelect = resData.list;
      });
    },

    handleSizeChange(val) {
      this.pageInfo.pageSize = val;
      this.getTableData(this.pageInfo.page);
    },
    handleCurrentChange(val) {
      this.pageInfo.page = val;
      this.getTableData(this.pageInfo.page);
    },

    openEditWin(index) {
      if (index === "create") {
        this.editOne = {
          uid: '',
          project_name: '',
          project_address: '',
          project_desc: ''
        };
        this.editType = "create";
      } else {
        this.editOne = {
          id: index.project_id,
          uid: index.uid,
          project_name: index.project_name,
          project_address: index.project_address,
          project_desc: index.project_desc
        };
        this.editType = "update";
      }
      this.dialogVisible = true;
    },

    updateItem() {
      this.$refs["dialogRef"].validate((valid) => {
        if (valid) {
          projectApi.projectEdit(this.editOne.id, this.editOne).then((res) => {
            if (res.data.code === 1000) {
              this.$message.success("修改成功");
              this.dialogVisible = false;
              this.getTableData(this.pageInfo.page);
            } else {
              this.$message.error(res.data.message);
            }
          });
        }
      });
      
    },
    createItem() {
      this.$refs["dialogRef"].validate((valid) => {
        if (valid) {
          projectApi.projectAdd(this.editOne).then((res) => {
            if (res.data.code === 1000) {
              this.$message.success("添加成功");
              this.dialogVisible = false;
              this.getTableData(this.pageInfo.page);
            } else {
              this.$message.error(res.data.message);
            }
          });
        }
      });
      
    },
    delItem(id) {
      this.$confirm("本操作将永久删除该项目，是否继续？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          projectApi.projectDel(id).then((res) => {
            if (res.data.code === 1000) {
              this.$message.success("删除成功");
              this.getTableData(this.pageInfo.page);
            } else {
              this.$message.error(res.data.message);
            }
          });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消删除",
          });
        });
    }
  },
  mounted() {
    this.getTableData(this.pageInfo.page);
  }
};
</script>
<style lang='less' scoped>
.project-content {
  width: 100%;
}
.map-container {
  padding-left: 100px;
  height: 180px;
  margin-bottom: 10px;
}
</style>